export interface IndexNameOptions {
  /** Append the `.old` fallback suffix (used when the primary index is empty). */
  old?: boolean
}

/**
 * Builds a distributor-scoped index name: `${prefix}${cooperativeId}.${locale}`,
 * with an optional `.old` fallback suffix.
 *
 * Centralizes the templating previously duplicated across the Vuex store, the
 * VSearch view and the product micro-front (coop prefix, national-coop prefix,
 * locale suffix and `.old` fallback).
 */
export function buildIndexName(
  prefix: string,
  cooperativeId: string | number,
  locale: string,
  { old = false }: IndexNameOptions = {},
): string {
  const indexName = `${prefix}${cooperativeId}.${locale}`
  return old ? `${indexName}.old` : indexName
}
